
import "./LoadingSpinner.css";

export default function LoadingSpinner({
  message = "Loading...",
  overlay = false,   // full screen if true
  small = false      //  compact inline if true
}) {
  return (
    <div className={overlay ? "spinner-overlay" : "spinner-inline"}>
      <div className={`spinner ${small ? "spinner-small" : ""}`} />
      {message && <p className="spinner-text">{message}</p>}
    </div>
  );
}
